import { darken } from '@chakra-ui/theme-tools';
import { StyleFunctionProps } from '@telescope/cassini-ui';

export const modalTheme = {
  baseStyle: (props: StyleFunctionProps) => {
    const { semanticTokens } = props.theme;
    const closeButtonColorBase = semanticTokens.colors['Modal-close-button-base'];
    const closeButtonColorSm = semanticTokens.colors['Modal-close-button-sm'];

    return {
      body: { p: [7, 0] },
      closeButton: {
        top: ['0px', '-10px'],
        right: ['0px', '-40px'],
        color: [closeButtonColorBase, closeButtonColorSm],
        _hover: {
          color: [darken(closeButtonColorBase, 20), darken(closeButtonColorSm, 20)],
        },
        _active: {
          color: [darken(closeButtonColorBase, 30), darken(closeButtonColorSm, 30)],
        },
      },
    };
  },
};
